import React, { useState } from 'react'

function todayISO() {
  return new Date().toISOString().slice(0, 10)
}

export default function DayOffRequestModal({ onClose, onSubmit }) {
  const [date, setDate] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async () => {
    if (!date) { setError('Pick a date.'); return }
    if (date < todayISO()) { setError('Date must be today or later.'); return }
    setBusy(true)
    setError('')
    try {
      await onSubmit({ date, reason })
    } catch (e) {
      setError(e.message || 'Error submitting')
    }
    setBusy(false)
  }

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.title}>REQUEST DAY OFF</div>
        <div style={styles.field}>
          <label style={styles.label}>DATE</label>
          <input
            type="date"
            min={todayISO()}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>REASON (OPTIONAL)</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={{ ...styles.input, minHeight: '70px', resize: 'vertical' }}
            placeholder="Short note for the crew lead..."
          />
        </div>
        {error && <div style={styles.error}>{error}</div>}
        <div style={styles.actions}>
          <button onClick={onClose} style={styles.cancelBtn}>CANCEL</button>
          <button onClick={handleSubmit} disabled={busy} style={styles.saveBtn}>
            {busy ? 'SUBMITTING...' : 'SUBMIT REQUEST'}
          </button>
        </div>
      </div>
    </div>
  )
}

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, fontFamily: "'Barlow', sans-serif" },
  modal: { backgroundColor: '#0d1420', border: '1px solid rgba(180,140,60,0.3)', borderRadius: '6px', width: 'min(90vw, 420px)', padding: '24px' },
  title: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '14px', fontWeight: 700, letterSpacing: '3px', color: '#b48c3c', marginBottom: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' },
  label: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: 600, letterSpacing: '2px', color: 'rgba(255,255,255,0.4)' },
  input: { backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px', padding: '12px 14px', color: '#ffffff', fontSize: '15px', fontFamily: "'Barlow', sans-serif", outline: 'none', width: '100%', boxSizing: 'border-box' },
  error: { backgroundColor: 'rgba(224,92,92,0.1)', border: '1px solid rgba(224,92,92,0.3)', borderRadius: '3px', padding: '10px 14px', color: '#e05c5c', fontSize: '13px', marginBottom: '10px' },
  actions: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '6px' },
  cancelBtn: { backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px', padding: '10px 16px', color: 'rgba(255,255,255,0.5)', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', letterSpacing: '2px', cursor: 'pointer' },
  saveBtn: { backgroundColor: '#b48c3c', border: 'none', borderRadius: '3px', padding: '10px 20px', color: '#0a0f1a', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: 700, letterSpacing: '2px', cursor: 'pointer' },
}
